import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { UserContext } from "../contexts";
import useWindowSize from "../hooks/useWindowSize";
import { BreadcrumbItem, IconName, RoutePath } from "../types";
import FooterBreadcrumbsItem from "./FooterBreadcrumbsItem";

const allBreadcrumbItems = [
  {
    icon: IconName.LOCATION,
    title: "Your Land",
    routes: [
      RoutePath.YOUR_LAND,
      RoutePath.PACKAGE_SEARCH,
      RoutePath.PACKAGE_SEARCH_RESULTS,
    ],
  },
  {
    icon: IconName.BLUEPRINT,
    title: "Floor Plan",
    routes: [RoutePath.CHOOSE_FLOOR_PLAN, RoutePath.PACKAGE_DETAILS],
  },
  {
    icon: IconName.HOUSE_OUTLINE,
    title: "Facade",
    routes: [RoutePath.CHOOSE_STREET_APPEAL],
  },
  {
    icon: IconName.TILES,
    title: "Exterior Style",
    routes: [RoutePath.CHOOSE_EXTERIOR_STYLE],
  },
  {
    icon: IconName.DISCOUNT,
    title: "Promotions",
    routes: [RoutePath.PROMOTIONS],
  },
  {
    icon: IconName.TOUCH,
    title: "Personal Touches",
    routes: [RoutePath.PERSONALISE_HOME, RoutePath.SIGN_UP],
  },
  {
    icon: IconName.DIAMOND,
    title: "Upgrade Options",
    routes: [RoutePath.UPGRADE_OPTIONS, RoutePath.TURN_KEY_INCLUSIONS],
  },
  {
    icon: IconName.FAN,
    title: "Lifestyle",
    routes: [RoutePath.LIFESTYLE_OPTIONS],
  },
  {
    icon: IconName.PARQUET,
    title: "Interior",
    routes: [RoutePath.INTERIOR_STYLE],
  },
  {
    icon: IconName.DISCOUNT,
    title: "Special Offers",
    routes: [RoutePath.SPECIAL_OFFERS, RoutePath.FINAL_DETAILS],
  },
  {
    icon: IconName.HOUSE_KEYS,
    title: "Your New Home",
    routes: [RoutePath.YOUR_NEW_HOME, RoutePath.THANK_YOU],
  },
];

const FooterBreadcrumbs = observer(() => {
  const userContext = useContext(UserContext);
  const location = useLocation();
  const windowSize = useWindowSize();

  const [activeIndex, setActiveIndex] = useState(-1);

  const [breadcrumbItems, setBreadcrumbItems] =
    useState<BreadcrumbItem[]>(allBreadcrumbItems);

  useEffect(() => {
    // Build the list of available breadcrumbs
    const routeList = userContext.getRouteList();
    const availableBreadcrumbItems = [...allBreadcrumbItems];
    const newBreadcrumbItems = [];
    for (const route of routeList) {
      for (let i = 0; i < availableBreadcrumbItems.length; i++) {
        if (availableBreadcrumbItems[i].routes.indexOf(route) > -1) {
          if (availableBreadcrumbItems[i].routes.indexOf(RoutePath.PROMOTIONS) > -1 && userContext.promotions.length <= 0) {
            //No Promotions, so don't add breadcrumb
          /*}else if (availableBreadcrumbItems[i].routes.indexOf(RoutePath.SPECIAL_OFFERS) > -1 && userContext.specialOffers.length <= 0) {*/
            //hardcode special offers to always be visible on client request, might need to uncomment this in future
            //No special offers, so don't add breadcrumb
          }else{
            newBreadcrumbItems.push(availableBreadcrumbItems[i]);
            // Remove the item so it doesn't get added multiple times - e.g. when multiple routes match a single item
            availableBreadcrumbItems.splice(i, 1);
          }
        }
      }
    }
    setBreadcrumbItems(newBreadcrumbItems);
  }, [userContext.landType, userContext.promotions, userContext.specialOffers]);

  useEffect(() => {
    // Search for the breadcrumb that matches the current path
    for (let i = 0; i < breadcrumbItems.length; i++) {
      if (
        breadcrumbItems[i].routes.indexOf(location.pathname as RoutePath) > -1
      ) {
        setActiveIndex(i);
        break;
      }
    }
  }, [location, breadcrumbItems]);

  useEffect(() => {
    // When either the window size or current active screen changes, try to center the active item in the viewport
    let offset = 0;
    if (windowSize.width < 768) {
      const $activeItem = $(".footer-breadcrumbs-item.active");
      const activeOffset =  $activeItem.offset();
      const activeItemWidth = $activeItem.width();
      const scrollLeft = $(".footer-breadcrumbs .container").scrollLeft();
      if(activeOffset !== undefined && activeItemWidth !== undefined && scrollLeft !== undefined){
        offset = activeOffset.left - (windowSize.width - activeItemWidth)/2 + scrollLeft;
      }
    }
    $(".footer-breadcrumbs .container").animate({"scrollLeft": offset+"px"});
  }, [windowSize.width, activeIndex, breadcrumbItems]);

  return (
    <div className={"footer-breadcrumbs"}>
      <div className={"container"}>
        <div
          className={"footer-breadcrumbs-items"}
        >
          {breadcrumbItems.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <FooterBreadcrumbsItem
                  key={item.title}
                  icon={item.icon}
                  title={item.title}
                  active={activeIndex === index}
                  visited={activeIndex > index}
                />
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default FooterBreadcrumbs;
